export default theme => ({
  container: {
    padding: 10,
    display: 'flex',
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif'
  },
  progressWrapper: {
    width: '100%',
    paddingTop: '48px',
    paddingBottom: '24px',
    display: 'flex',
    justifyContent: 'center'
  },
  mainContainer: {
    marginRight: 20,
    width: 'calc( 70% - 20px )',
    borderRight: '1px solid gray'
  },

  detailsContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: 10
  },
  left: {
    width: 'calc( 50% - 5px )'
  },
  right: {
    width: 'calc( 50% - 5px )'
  },
  subDetailsContainer: {
    border: '1px solid #d8d8d8',
    padding: 20,
    marginBottom: 10
  },
  locationButtons: {
    display: 'flex',
    padding: 10,
    marginBottom: 10,
    justifyContent: 'space-between'
  },
  locationButton: {
    width: 'calc( 40% - 10px )',
    '&:first-child': {
      width: 'calc( 60% - 10px )'
    }
  },
  item: {
    fontWeight: 'bold',
    float: 'right'
  },
  deliveryBy: {
    marginBottom: 10
  },
  bill: {
    width: '30%',
    height: '100%',
    overflow: 'auto'
  },
  products: {
    maxHeight: '50vh',
    overflow: 'auto',
    marginTop: 10
  },
  productCell: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  cellItem: {
    marginBottom: '15px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    '&:first-child': {
      width: '90%'
    }
  },
  dateText: {
    color: theme.palette.text.secondary
  },
  productPrice: {
    marginTop: '20px',
    fontWeight: 'bold',
    display: 'flex',
    justifyContent: 'space-between',
    '& p': {
      fontWeight: 'bold'
    }
  },
  customerHeading: {
    fontWeight: 'bold'
  },
  customerDetails: {
    position: 'relative',
    marginTop: 10,
    width: '100%',
    display: 'flex',
    flexDirection: 'column'
  },
  address: {
    display: 'flex',
    flexDirection: 'column'
  },
  subCustomerDetails: {
    marginBottom: 5
  },
  subAddress: {
    marginBottom: 2
  },
  location: {
    position: 'absolute',
    right: 5
  },
  billDetails: {
    width: '100%',
    '&:last-child': {
      marginTop: 8
    },
    '&:nth-child(2)': {
      marginTop: 10
    }
  },
  billTitle: {
    fontWeight: 'bold',
    paddingBottom: 5
  },
  productHeading: {
    fontWeight: 'bold',
    marginBottom: 5
  },
  action: {
    boxShadow: '0px 1px 8px -3px #888888',
    width: '100%',
    display: 'flex',
    height: 56,
    justifyContent: 'space-between',
    padding: '10px 20px',
    '& .bill': {
      display: 'none'
    }
  },
  iconButtons: {
    position: 'absolute',
    right: 20,
    '& > button': {
      marginLeft: 10
    },
    '&> button:last-child': {
      marginLeft: 20
    }
  },
  footerIcons: {
    width: 30,
    height: 30
  },

  printBill: {
    padding: 40
  },
  billHeading: {
    padding: 20,
    border: '1px solid gray',
    display: 'flex'
  },
  billLeftHeading: {
    width: '50%'
  },
  billRightHeading: {
    width: '50%',
    display: 'flex',
    flexDirection: 'column'
  },
  billBody: {
    display: 'flex',
    flexDirection: 'column'
  },
  billCharges: {
    width: '100%',
    marginTop: 20,
    border: '1px solid gray',
    padding: '20px 40px'
  },
  billSubDetailsContainer: {
    width: '60%',
    marginLeft: '40%'
  },
  billDetailsCon: {
    display: 'flex',
    padding: '2px 20px',
    justifyContent: 'space-between',
    fontSize: '18px'
  },
  billSubHeading: {
    width: '50%',
    textAlign: 'right',
    fontSize: '18px'
  },
  billSubitem: {
    width: '30%',
    textAlign: 'left',
    fontWeight: 'bold',
    fontSize: '17px'
  },
  billSubHeadingText: {
    padding: '5px 10px 0px 20px',
    textAlign: 'left',
    width: '100%',
    fontSize: '17px'
  },
  tableCell: {
    fontSize: '17px',
    padding: '5px 5px !important',
    '&:first-child': {
      width: '110%'
    },
    '& svg': {
      width: 80,
      height: 40,
      marginRight: 5
    }
  },
  tableHeaderCell: {
    '&:first-child': {
      width: '60%'
    }
  },
  tableRow: {
    height: 40
  }

})
